import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImplementationComponent } from './implementation/implementation.component';
import { FooterImplementComponent } from './components/footer-implement/footer-implement.component';
import { BackToTopComponent } from './components/back-to-top/back-to-top.component';
import { HeaderImplementComponent } from './components/header-implement/header-implement.component';
import { HeaderDesktopImplementComponent } from './components/header-desktop-implement/header-desktop-implement.component';
import { HeaderMobileImplementComponent } from './components/header-mobile-implement/header-mobile-implement.component';
import { BarraAccesibilidadImplementComponent } from './components/barra-accesibilidad-implement/barra-accesibilidad-implement.component';


@NgModule({
  declarations: 
  [
    ImplementationComponent, 
    FooterImplementComponent,
    BarraAccesibilidadImplementComponent,
    BackToTopComponent, HeaderImplementComponent, HeaderDesktopImplementComponent, HeaderMobileImplementComponent
  ],
  imports: [
    CommonModule
  ]
})
export class TransversalesModule { }
